import { ReleaseType } from '@ibk/shared-types';
import { formatCurrency } from '@ibk/shared-utils';
import { getUnformatedValue, isActiveStatus } from '../../../../../utils/beneficiaryUtils';
const DEFAULT_CURRENCY_VALUE = 'R$ 0,00';
export function getInitialReleaseTypeFromProduct(products, voucherTypeId, formDataReleaseType) {
    if (formDataReleaseType) {
        return formDataReleaseType;
    }
    const product = products.find(p => p.voucherType === voucherTypeId);
    if (product?.releaseType) {
        return product.releaseType;
    }
    return ReleaseType.MONTHLY;
}
export function getInitialBeneficiaryHistory(products, voucherTypeId, formData) {
    const product = products.find(p => p.voucherType === voucherTypeId);
    const productReleaseType = product?.releaseType;
    const monthlyValue = product?.baseValue ? formatCurrency(product.baseValue) : DEFAULT_CURRENCY_VALUE;
    const dailyValue = product?.amountDaily ? formatCurrency(product.amountDaily) : DEFAULT_CURRENCY_VALUE;
    return {
        monthly: {
            values: productReleaseType === ReleaseType.MONTHLY || formData.releaseType === ReleaseType.MONTHLY
                ? (formData.beneficiaries ?? null)
                : null,
            globalValue: formData.releaseType === ReleaseType.MONTHLY ? (formData.globalValue ?? monthlyValue) : monthlyValue,
        },
        daily: {
            values: productReleaseType === ReleaseType.DAILY || formData.releaseType === ReleaseType.DAILY
                ? (formData.beneficiaries ?? null)
                : null,
            globalValue: formData.releaseType === ReleaseType.DAILY ? (formData.globalValue ?? dailyValue) : dailyValue,
        },
    };
}
export function applyGlobalValuesToBeneficiaries(beneficiaries, globalValue, releaseType, businessDays) {
    if (!beneficiaries.length || !globalValue || globalValue === DEFAULT_CURRENCY_VALUE) {
        return beneficiaries;
    }
    const globalNumericValue = getUnformatedValue(globalValue);
    const isDaily = releaseType === ReleaseType.DAILY;
    return beneficiaries.map(beneficiary => {
        if (isActiveStatus(beneficiary.statusInProduct)) {
            if (isDaily && businessDays > 0) {
                const totalValue = globalNumericValue * businessDays;
                return {
                    ...beneficiary,
                    productValue: totalValue,
                    productDaysQuantity: businessDays,
                    importedFields: undefined,
                };
            }
            else if (!isDaily) {
                return {
                    ...beneficiary,
                    productValue: globalNumericValue,
                    productDaysQuantity: 0,
                    importedFields: undefined,
                };
            }
        }
        return beneficiary;
    });
}
